module.exports = __webpack_public_path__ + "img/4ab49b3e-e26d-4f9f-b28d-3eb0603118e3.webp.b6e26417.jpg";